import { rem } from '@mantine/core'

export default {
  none: rem(0),
  hairline: rem(1),
  thin: rem(2),
  thick: rem(3)
}
